import { EventBase } from "@vp/models";
import { PaymentTransactionResult } from "../common";

export class TransactionStatusEvent extends EventBase<PaymentTransactionResult> {
  constructor(private result: PaymentTransactionResult) {
    super();
    this.args = this.result;
  }
}
